const CREDIT_CARD_BASE_URL = '/credit-card';
export const ONBOARDING_BASE_URL = `${CREDIT_CARD_BASE_URL}/onboarding`;
export const ONBOARDING_PATHS = {
    ONBOARDING_CHECKS: `${ONBOARDING_BASE_URL}/checks/`,
    ONBOARDING_DOCUMENTS: `${ONBOARDING_BASE_URL}/documents/`,
    ONBOARDING_PAYMENT_METHOD: `${ONBOARDING_BASE_URL}/payment-method/`
};
